import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    email: "",
  },
  IsEmailExists: false,
};
const resetPasswordFormSlice = createSlice({
  name: "sendEmail",
  initialState,
  reducers: {
    onFormChanges: (state, action) => {
      state.value = action.payload;
    },
    setIsEmailExists: (state, action) => {
      state.IsEmailExists = action.payload;
    },
    resetPasswordForm() {
      return initialState;
    },
  },
});

export const { onFormChanges, setIsEmailExists, resetPasswordForm } =
  resetPasswordFormSlice.actions;

export default resetPasswordFormSlice.reducer;
